// extracted by mini-css-extract-plugin
module.exports = {"tempsLectura":"tempsLectura_tempsLectura__X63qb","inline":"tempsLectura_inline__Z25Cl"};